var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-slider"},_vm._l((_vm.datesList),function(date){return _c('div',{key:date.valueOf(),staticClass:"date-item",class:{
      'date-item--active': _vm.isActiveDate(date),
      'date-item--loading': _vm.loading && !_vm.isActiveDate(date),
    },on:{"click":function($event){return _vm.setActiveDate(date)}}},[_c('div',{staticClass:"date-item__content"},[_c('p',{staticClass:"caption date-item__weekday"},[_vm._v(_vm._s(_vm.weekDay(date)))]),_c('p',{staticClass:"small-medium text-center",class:{
          'text-gray-light': _vm.isWeekend(date),
        }},[_vm._v(_vm._s(_vm.monthDay(date)))])])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }